<template>
  <div class="sale">
    <span v-if="priceInfo.preFormat" class="ssu-unit-format">{{
      priceInfo.preFormat
    }}</span>
    <span v-if="priceInfo.unitPricePrefix" class="ssu-sale-prefix">{{
      priceInfo.unitPricePrefix
    }}</span>
    <span class="ssu-sale-money">{{ priceInfo.priceSymbol }}</span>
    <span class="ssu-sale-price">{{ priceInfo.priceValue }}</span>
    <span class="ssu-sale-unit">{{ priceInfo.priceUnitText }}</span>
    <span class="total-price-fp">{{ totalPriceWithFp }}</span>
  </div>
</template>

<script>
import {
  getSsuPriceInfo,
  getTotalPriceWithFp,
  getSkuPriceInfo
} from '../priceUtil'

export default {
  props: {
    ssu: {
      type: Object,
      default: () => null
    },
    sku: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {}
  },
  computed: {
    priceInfo() {
      let priceInfo = {}
      if (this.ssu) {
        const ssuPrice = this.ssu?.ssuPrice
        const {
          priceSymbol,
          priceValue,
          priceUnitText,
          unitPricePrefix,
          preFormat
        } = getSsuPriceInfo(ssuPrice)
        priceInfo = {
          priceSymbol,
          priceValue,
          priceUnitText,
          unitPricePrefix,
          preFormat
        }
      } else if (this.sku) {
        const skuPrice = this.sku.skuPrice
        skuPrice.skuUnit = this.sku.skuBase?.skuUnit
        const {
          priceSymbol,
          // priceValue,
          priceUnitText,
          minPrice
        } = getSkuPriceInfo(skuPrice)
        priceInfo = {
          priceSymbol,
          priceValue: minPrice,
          priceUnitText: priceUnitText + '起'
        }
      }
      return priceInfo
    },
    totalPriceWithFp() {
      const ssuPrice = this.ssu?.ssuPrice
      const totalPriceWithFp = getTotalPriceWithFp(ssuPrice)
      return totalPriceWithFp
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.sale {
  display: flex;
  align-items: baseline;
  flex: auto;
  width: 0;
  @include text-overflow-ellipsis;
  .ssu-unit-format {
    line-height: 18px;
    text-align: center;
    padding: 0 4px;
    height: 18px;
    background: #f5f5f5;
    border-radius: 4px;
    font-weight: 700;
    font-size: 13px;
    color: #262626;
  }
  .ssu-sale-money {
    color: #f03100;
    font-weight: bold;
    font-size: 12px;
  }
  .ssu-sale-price {
    font-weight: bold;
    font-size: 20px;
    color: #f03100;
  }
  .ssu-sale-unit {
    font-weight: bold;
    font-size: 13px;
    color: #f03100;
  }
  .ssu-sale-prefix {
    margin-right: 1px;
    color: #f03100;
    font-size: 10px;
    font-weight: bold;
  }
  .total-price-fp {
    @include text(13px, #262626);
    white-space: nowrap;
    margin-left: 2px;
  }
}
</style>
